import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const PriorityCallsList = () => {
    const { chartData } = useServicesChartsDataContext();
    

    const tableColumns = [
            {
                key: 'description',
                header: 'Mês',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'azul',
                header: 'Azul',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'verde',
                header: 'Verde',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'amarelo',
                header: 'Amarelo',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'laranja',
                header: 'Laranja',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'vermelho',
                header: 'Vermelho',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'ignorado',
                header: 'Ignorado',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
    ];

    return (
        <div style={{ width: '100%', display: 'flex' }}>
            <TableComponent
                data={chartData?.priorityCallsList}
                columns={tableColumns}
                title="Resultados dos chamados mensais de acordo com a sua prioridade"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};